/**
 * Human-readable coarse countdown for a store deal, e.g. "2h 15m left".
 *
 * Used only for deals ending within 24h (see StoreDealIndicator). Above 24h we
 * show a static "Limited time" label instead of a timer, per the COM-681 design.
 *
 * - >= 1h  -> "Xh Ym left"  (e.g. "2h 15m left", "5h 0m left")
 * - < 1h   -> "Xm left"     (e.g. "45m left")
 * - < 1m   -> "1m left"     (floor to a minimum of one minute while > 0)
 */
export function formatCoarseRemaining(totalSeconds: number): string {
  const safeSeconds = Math.max(0, Math.floor(totalSeconds));
  const hours = Math.floor(safeSeconds / 3600);
  const minutes = Math.floor((safeSeconds % 3600) / 60);

  if (hours > 0) {
    return `${hours}h ${minutes}m left`;
  }

  const atLeastOneMinute = Math.max(1, minutes);
  return `${atLeastOneMinute}m left`;
}
